import { render, staticRenderFns } from "./chooseTag.vue?vue&type=template&id=32c60fb4&scoped=true&"
import script from "./chooseTag.vue?vue&type=script&lang=js&"
export * from "./chooseTag.vue?vue&type=script&lang=js&"
import style0 from "./chooseTag.vue?vue&type=style&index=0&id=32c60fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c60fb4",
  null
  
)

export default component.exports